import React, { useEffect, useState } from 'react';

// Material UI
import { Typography, Grid, Zoom, Button, DialogActions } from "@mui/material"

// Components
import Modal from "../../../../../components/modal/index";
import Spinner from '../../../../../components/spinner';
import { cardTypeFormat, subTypeSales } from "../../../../../models/CashRegisterMovementEntity";
import RealTotal from './real';

import { utils } from '../../../../../utils/utils';

const Transition = React.forwardRef(function Transition (props, ref) {
    return <Zoom ref={ref} {...props} />;
});

const ViewTotal = ({ open, onClose, loading, details, cardSelected, onAccept }) => {
    const [valueTypes, setValueTypes] = useState(null);

    useEffect(() => {
        setValueTypes(details);
    }, [cardSelected?.id, details])

    const handleInputChange = (event, type) => {
        const value = event.target.value;
        if (!utils.ValidateValueIsString(value))
            if (value >= 0) {
                if (valueTypes[type]) {
                    valueTypes[type][event.target.name] = value;
                } else {
                    valueTypes[type] = { [event.target.name]: value };
                }

                setValueTypes({
                    ...valueTypes,
                })
            }
    }
    return (
        <Modal
            fullWidth
            dividers
            maxWidth='md'
            open={open}
            onClose={onClose}
            title={`${cardSelected?.name} ${cardSelected?.type && cardTypeFormat[cardSelected.type]}`}
            TransitionComponent={Transition}
            disableEscapeKeyDown
            customButtons={() => (
                <DialogActions>
                    <Button color='primary' variant='outlined' onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button
                        color='primary'
                        variant='contained'
                        onClick={(ev) => onAccept(ev, valueTypes, cardSelected?.id)}
                    >
                        Aceptar
                    </Button>
                </DialogActions>
            )}
        >
            <Grid container>
                {
                    loading &&
                    <Grid size={12}>
                        <Spinner />
                    </Grid>
                }
                {!loading &&
                    <Grid size={12}>
                        <Grid container spacing={1} justifyContent='flex-end'>
                            <Grid size={4}>
                                <Typography color='primary' variant="h6" component='p' align='right'>
                                    <strong>TOTALES</strong>
                                </Typography>
                            </Grid>
                            <Grid size={5}>
                                <Typography color='primary' variant="h6" component='p' align='right'>
                                    <strong>CUPONES</strong>
                                </Typography>
                            </Grid>
                            <Grid size={12}>
                                {Object.values(subTypeSales).map(type =>
                                    <RealTotal
                                        key={type}
                                        type={type}
                                        detail={valueTypes}
                                        onChange={handleInputChange}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Modal>
    );
}

export default ViewTotal;